import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ 'trigger', 'content' ];

    connect() {
        // Les images lazy dans un contenu en display:none ne sont jamais chargées
        // avant l'ouverture : on les passe en eager quand le bloc approche du viewport.
        this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            this.element.querySelectorAll('img[loading="lazy"]').forEach((img) => {
                img.loading = 'eager';
            });
            this.observer.disconnect();
        }, { rootMargin: '400px 0px' });

        this.observer.observe(this.element);
    }

    disconnect() {
        this.observer?.disconnect();
    }

    toggle(event) {
        const clickedTrigger = event.currentTarget;
        const isOpening = clickedTrigger.getAttribute('aria-expanded') === 'false';

        if (isOpening) {
            // Fermer tous les items
            this.triggerTargets.forEach((trigger) =>
                trigger.setAttribute('aria-expanded', 'false')
            );

            this.contentTargets.forEach((content) => {
                content.setAttribute('aria-expanded', 'false');
                this.updateContentAnimation(content, false);
            });

            // Ouvrir l’item courant
            clickedTrigger.setAttribute('aria-expanded', 'true');

            const currentContent = this.getContentForTrigger(clickedTrigger);
            if (!currentContent) return;

            currentContent.setAttribute('aria-expanded', 'true');
            this.updateContentAnimation(currentContent, true);
        } else {
            // Fermer uniquement l’item courant
            clickedTrigger.setAttribute('aria-expanded', 'false');

            const currentContent = this.getContentForTrigger(clickedTrigger);
            if (!currentContent) return;

            currentContent.setAttribute('aria-expanded', 'false');
            this.updateContentAnimation(currentContent, false);
        }
    }

    getContentForTrigger(trigger) {
        const contentId = trigger.getAttribute('aria-controls');
        return this.contentTargets.find((content) => content.id === contentId) || null;
    }

    updateContentAnimation(content, shouldAnimate) {
        const items = content.querySelectorAll('[data-content-animate]');
        if (!items.length) return;

        if (shouldAnimate) {
            setTimeout(() => {
                items.forEach((item) => item.classList.add('animating'));
            }, 100);
        } else {
            items.forEach((item) => item.classList.remove('animating'));
        }
    }
}
